const borderColor = '#979797';
const leftColor = '#B8B8B8';
const rightColor = '#5597B4';
export { borderColor, leftColor, rightColor };
